<template>
  <el-dialog title="添加新Key"
             :visible.sync="paramShow.addKeyVisible"
             width="50%"
             :close-on-click-modal="false"
             @close="DialogClosed('addKeyFormRef')">
    <el-form :model="addKeyForm"
             :rules="addKeyFormRules"
             ref="addKeyFormRef"
             label-width="145px"
             @submit.native.prevent>
      <el-form-item label="Key名称"
                    prop="keyName">
        <el-input v-model="addKeyForm.keyName"
                  placeholder="支持字母、数字、下划线，起名时尽量清晰简洁的表示业务身份"></el-input>
      </el-form-item>
      <el-form-item label="服务平台"
                    prop="platform">
        <el-radio-group v-model="addKeyForm.platform">
          <el-radio v-for="item in platformList" :key="item.code" :label="item.code">{{ item.name }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="addKeyForm.platform === 1"
                    prop="openSign">
        <span slot="label">
          <el-tooltip effect='dark'
                      placement='top'>
            <span slot="content">数字签名开启后，您设置的Key所发起的所有请求都必须以数字签名的方式提交
              <br /> <a src="" class="link">查看数字签名说明与添加方式</a>
            </span>
            <i class="el-icon-question">数字签名</i>
          </el-tooltip>
        </span>
        <el-switch v-model="addKeyForm.openSign">签名校验</el-switch>
      </el-form-item>
      <el-form-item label="IP白名单"
                    v-if="addKeyForm.platform === 1"
                    prop="whiteList">
        <el-input v-model="addKeyForm.whiteList"
                  placeholder="非必填，留空表示无IP 限制，添加IP或IP段（以-隔开） 白名单后，只有白名单中的IP 可访问服务，多个IP（段） 请分多行展示，最多可添加100 个IP（段）"
                  type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="域名白名单"
                    v-if="addKeyForm.platform === 3"
                    prop="whiteList">
        <el-input v-model="addKeyForm.whiteList"
                  placeholder="非必填，留空表示无域名限制，添加域名白名单后，只有白名单中的域名可访问服务，多个域名请分多行展示，最多可添加100 个域名，示例: lbs.meituan.com"
                  type="textarea"></el-input>
      </el-form-item>
      <div v-if="addKeyForm.platform === 4">
        <el-row
          v-for="(item, index) in addKeyForm.authInfo.androidAuths"
          :key="index"
        >
          <el-col :span="22">
            <el-form-item
              label="发布版安全码SHA1"
              :prop="`authInfo.androidAuths[${index}].sha1`"
              :rules="addKeyFormRules.androidAuths.sha1"
            >
              <el-input
                v-model="item.sha1"
                placeholder="请输入发布版安全码SHA1"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="调试安全码SHA1"
              :prop="`authInfo.androidAuths[${index}].debugSha1`"
              :rules="addKeyFormRules.androidAuths.debugSha1"
            >
              <el-input
                v-model="item.debugSha1"
                placeholder="请输入调试安全码SHA1"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="PackageName"
              :prop="`authInfo.androidAuths[${index}].packageName`"
              :rules="addKeyFormRules.androidAuths.packageName"
            >
              <el-input
                v-model="item.packageName"
                placeholder="请输入包名，如：com.meituan.sdk，每条配置可授权一个包名，最多可有20条配置"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" style="padding: 38px 0px 0px 5px">
            <el-button
              v-show="deleteShow"
              type="danger"
              size="mini"
              @click="deleteAndroid(index)"
              >删除</el-button
            >
          </el-col>
        </el-row>
        <el-form-item size="small">
          <el-button type="primary" @click="addSetting">新增一条配置</el-button>
          <el-button type="danger" @click="deleteShow = !deleteShow"
            >删除配置</el-button
          >
        </el-form-item>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="paramShow.addKeyVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="addKeyInfo">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import http from '@/http/index.js'

export default {
  props: ['paramShow', 'addAppKeyItem'],
  data() {
    const checkKeyName = (rule, value, cb) => {
      // 字母数组下划线的组合
      const regEmail = /^[0-9a-zA-Z_]{1,}$/;
      if (regEmail.test(value)) {
        // 合法的Key名
        return cb();
      }
      cb(new Error('Key 名称不符合规范，支持字母、数字、下划线，请检查'));
    };
    const checkWhiteList = (rule, value, cb) => {
      if (value === null || value === '' || value === undefined) {
        return cb();
      }
      if (this.addKeyForm.platform === 1) {
      // IP校验
        const reg =
        /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        const valdata = value.split('\n');
        for (let i = 0; i < valdata.length; i++) {
          if (valdata[i].includes('-')) {
            valdata[i].split('-').forEach(item => {
              if (reg.test(item) === false) {
                cb(new Error('IP 规则不符合规范，请检查'));
                return false;
              }
            })
          } else if (reg.test(valdata[i]) === false) {
            cb(new Error('IP 规则不符合规范，请检查'));
            return false;
          }
        }
        return cb();
      } else if (this.addKeyForm.platform === 3) {
        const reg = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
        const valdata = value.split('\n');
        if (valdata.length > 100) {
          cb(new Error('域名数量不能超过100条'));
          return false;
        }
        for (let i = 0; i < valdata.length; i++) {
          if (reg.test(valdata[i]) === false) {
            cb(new Error('域名规则不符合规范，请检查'));
            return false;
          }
        }
        return cb();
      }
    };
    const checkSha1 = (rule, value, cb) => {
      if (!value) {
        return cb();
      }
      if (/^([0-9A-F]{2})([:][0-9A-F]{2}){19}$/.test(value)) {
        cb();
      }
      cb(new Error('不符合规范，请检查'));
    };
    const checkPackageName = (rule, value, cb) => {
      if (
        /^([a-zA-Z_][a-zA-Z0-9_]*)+([.][a-zA-Z_][a-zA-Z0-9_]*)+$/.test(value)
      ) {
        cb();
      }
      cb(new Error('不符合规范，请检查'));
    };
    return {
      deleteShow: false,
      labelMap: {
        1: {
          label: 'IP白名单',
          prop: 'whiteList',
          placeholder:
            '非必填，留空表示无IP 限制，添加IP或IP段（以-隔开） 白名单后，只有白名单中的IP 可访问服务，多个IP（段） 请分多行展示，最多可添加100 个IP（段）'
        },
        3: {
          label: '域名白名单',
          prop: 'hostCheck',
          placeholder:
            `非必填，留空表示无域名限制，添加域名白名单后，只有白名单中的域名可访问服务，多个域名请分多行展示，最多可添加100 个域名，示例: lbs.meituan.com`
        }
      },
      addKeyForm: {
        keyName: null,
        platform: 1,
        whiteList: null,
        appId: null,
        authInfo: {
          androidAuths: []
        }
      },
      platformList: [],
      addKeyFormRules: {
        keyName: [
          { required: true, message: '请输入Key名称', trigger: 'blur' },
          {
            max: 50,
            message: 'Key 名称超长，最长支持50 字符',
            trigger: 'blur'
          },
          { validator: checkKeyName, trigger: 'blur' }
        ],
        platform: [
          { required: true, message: '请勾选服务平台', trigger: 'change' }
        ],
        whiteList: [{ validator: checkWhiteList, trigger: 'blur' }],
        androidAuths: {
          sha1: [
            { required: true, message: '请输入sha1值', trigger: 'blur' },
            { validator: checkSha1, trigger: 'blur' }
          ],
          debugSha1: [{ validator: checkSha1, trigger: 'blur' }],
          packageName: [
            {
              required: true,
              message: '请输入packageName值',
              trigger: 'blur'
            },
            { validator: checkPackageName, trigger: 'blur' }
          ]
        }
      }
    };
  },
  watch: {
    'addKeyForm.platform': {
      handler(newVal, oldVal) {
        if ([1, 2, 3].includes(this.addKeyForm.platform)) {
          this.addKeyForm.authInfo = {
          }
        } else {
          delete this.addKeyForm.whiteList
          this.addKeyForm.authInfo = {
          }
        }
        if (newVal === 4) {
          this.addKeyForm.authInfo = {
            androidAuths: []
          }
          this.addKeyForm.authInfo.androidAuths = [
            { sha1: null, debugSha1: null, packageName: null }
          ];
        }
        this.$refs.addKeyFormRef &&
          this.$refs.addKeyFormRef.clearValidate([
            'whiteList'
          ]);
      },
      immediate: true
    }
  },
  methods: {
    addSetting() {
      if (this.addKeyForm.authInfo.androidAuths.length > 20) {
        this.$message({
          message: '最多新增20条配置！',
          type: 'warning'
        });
        return;
      }
      this.addKeyForm.authInfo.androidAuths.push({
        sha1: null,
        debugSha1: null,
        packageName: null
      });
    },
    deleteAndroid(index) {
      if (this.addKeyForm.authInfo.androidAuths.length === 1) {
        this.$message({
          message: '须保留至少一组配置',
          type: 'warning'
        });
      } else {
        this.$confirm('此操作将删除该行配置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.addKeyForm.authInfo.androidAuths.splice(index, 1);
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
          .catch(() => {});
      }
    },
    async addKeyInfo() {
      // 添加Key
      this.$refs.addKeyFormRef.validate(async (valid) => {
        if (!valid) return;
        await http.key.add(this.addKeyForm);

        // 关闭对话框
        this.paramShow.addKeyVisible = false;
        // 刷新数据列表
        this.$emit('updateActive', this.addAppKeyItem.name);
        this.$emit('updateList');
        // 提示修改成功
        this.$message.success('添加Key成功！');
      });
    },
    DialogClosed(ref) {
      this.$refs[ref].resetFields();
    }
  },
  async created() {
    if (this.addAppKeyItem && this.addAppKeyItem.appId) {
      this.addKeyForm.appId = this.addAppKeyItem.appId;
    }
    this.platformList = await http.key.platform()
  }
};
</script>

<style lang="less" scoped>
.link{
  color: #476EEF;
}
.link:hover{
  cursor: pointer;
}
</style>
